import { render, staticRenderFns } from "./ClickAndBuysStruct.vue?vue&type=template&id=7dcf15b7&scoped=true"
import script from "./ClickAndBuysStruct.vue?vue&type=script&lang=js"
export * from "./ClickAndBuysStruct.vue?vue&type=script&lang=js"
import style0 from "./ClickAndBuysStruct.vue?vue&type=style&index=0&id=7dcf15b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcf15b7",
  null
  
)

export default component.exports